module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Применить","flags":["TRACK"],"track":"Apply"}}